import React, { useState } from 'react';
import { BoxButton, FlexWrapper } from '../../../../theme/common_style';
import Title from 'antd/es/typography/Title';
import SearchField from '../../../../components/searchField/SearchField';
import { Button } from 'antd';
import TabNav from '../../../employees/view-employee/components/TabNav';
import { updateDocActiveTab } from '../../../../redux/employee/EmployeeSlice';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import AllDocs from '../../../../modules/employees/view-employee/components/AllDocs';
import Collections from '../../../../modules/employees/view-employee/components/Collections';
import SortByDropdown from '../../../employees/view-employee/components/SortButton';
import DocFilter from '../../../employees/view-employee/components/DocFilter';
import { checkPermission } from '../../../../utils/common_functions';
import { useCurrentModule } from '../../../../hooks/useCurrentModule';
import FilterButton from '../../../../components/common/FilterButton';
import styled from '@emotion/styled';

const Documents = () => {
  const [filterDrawer, setFilterDrawer] = useState(false);
  const hmsActiveTab = useSelector((state) => state?.HmsSlice?.HmsTab);
  const [search, setSearch] = useState('');
  const [addModal, setAddModal] = useState(false);

  const { permissions } = useSelector((state) => state?.userInfo?.data);
  let permissionSection = useCurrentModule();
  const canCreate = checkPermission(permissionSection, 'create', permissions);

  const dispatch = useDispatch();
  const { docActiveTab: activeTab } = useSelector((state) => state?.employeeSlice);
  const [filterData, setFilterData] = useState({});

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const sortOptions = [
    { label: 'Name', value: 'document' },
    { label: 'Created At', value: 'created_at' }
  ];
  const sortOptionsColl = [{ label: 'Name', value: 'collection_name' }];

  const TabList = [
    {
      name: 'All'
    },
    {
      name: 'Collection'
    }
  ];

  const handleActiveTabs = (val) => {
    setSearch('');
    setSortField(null);
    setSortOrder(null);
    dispatch(updateDocActiveTab(val));
  };

  return (
    <div>
      {filterDrawer && (
        <DocFilter
          open={filterDrawer}
          onClose={() => setFilterDrawer(false)}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      )}
      <FlexWrapper
        width={'100%'}
        justify={'space-between'}
        gap="16px"
        cursor="default"
        margin="12px 0"
        style={{ marginBottom: '16px' }}>
        <Title level={4} style={{ margin: 0 }}>
          {hmsActiveTab === 'Inventory'
            ? 'Documents'
            : hmsActiveTab === 'Assignee'
            ? 'Device Photos'
            : 'Documents'}
        </Title>
        <FlexWrapperHeader justify={'end'} gap="6px" cursor="default">
          <SearchField
            placeholder="Search by Name..."
            width={'250px'}
            value={search}
            onChange={setSearch}
          />
          <BoxButton>
            <SortByDropdown
              sortField={sortField}
              setSortField={setSortField}
              sortOrder={sortOrder}
              setSortOrder={setSortOrder}
              sortOptions={activeTab === 1 ? sortOptions : sortOptionsColl}
            />
            {activeTab === 1 && (
              <FilterButton appliedFilter={filterData} handleClick={() => setFilterDrawer(true)} />
            )}
          </BoxButton>
          {canCreate && (
            <Button type="text" onClick={() => setAddModal(true)} prefixCls="antCustomBtn">
              + Upload
            </Button>
          )}
        </FlexWrapperHeader>
      </FlexWrapper>

      <TabNav list={TabList} activeTab={activeTab} setActiveTab={handleActiveTabs} />

      {activeTab === 1 ? (
        <AllDocs
          search={search}
          addModal={addModal}
          setAddModal={setAddModal}
          filter={filterData}
          sortField={sortField}
          sortOrder={sortOrder}
          apiPath="hms"
        />
      ) : (
        <Collections
          search={search}
          addModal={addModal}
          setAddModal={setAddModal}
          sortField={sortField}
          sortOrder={sortOrder}
          apiPath="hms"
          navigatePath="hms/details"
        />
      )}
    </div>
  );
};

Documents.propTypes = {
  hmsActiveTab: PropTypes.string
};

export default Documents;
const FlexWrapperHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 16px;

  @media (max-width: 868px) {
    width: 100%;
    flex-wrap: wrap;
    align-items: start;
    justify-content: start;
  }
  @media (max-width: 68px) {
    width: 100%;
    flex-direction: column;
  }
`;
